import { createAppSlice } from '../../app/createAppSlice'

const initialState = {on: false};

const editModeSlice = createAppSlice({
    name: "editMode",
    initialState,
    reducers: create => ({
        editModeOn: create.reducer((state) => { state.on = true; }),
        editModeOff: create.reducer((state) => { state.on = false; }),
    }),
    selectors: {
        selectEditMode: editMode => editMode.on
    },
})

export const { editModeOn, editModeOff } = editModeSlice.actions

export const { selectEditMode } = editModeSlice.selectors

export default editModeSlice